// src/utils/teacherHelper.js
// Single source of truth for resolving a Firebase Auth uid -> teacher doc.
// Used by TeacherRoute, and (Phase 1b) by Login.js and ProtectedRoute.
import { db } from '../firebase';
import { collection, query, where, getDocs, limit } from 'firebase/firestore';

export async function getTeacherByAuthUid(uid) {
  if (!uid) return null;
  const snap = await getDocs(
    query(collection(db, 'teachers'), where('authUid', '==', uid), limit(1))
  );
  if (snap.empty) return null;
  const d = snap.docs[0];
  return { id: d.id, ...d.data() };
}
